import { useGetNumberOfDatasourcesPerSubscriptionQuery } from '@/features/credits/apiSlice';
import { useDatasourceId } from '@/hooks';

export const useDatasourceCountPerSubscription = (): number => {
  const datasourceId = useDatasourceId();
  const { data: numberOfDatasources = 0 } =
    useGetNumberOfDatasourcesPerSubscriptionQuery(datasourceId);

  return numberOfDatasources;
};
